import { useNavigate } from "react-router-dom";

export default function useLogout() {
  const navigate = useNavigate();

  const logout = () => {
    // 1. Clear credentials
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("permissions");

    // 2. Clear all context/global state here if applicable
    // e.g., setAuth(null) or dispatch({ type: 'LOGOUT' })

    // 3. Perform routing reset
    navigate("/", { replace: true });

    // 4. Fallback: If you are not using a global state context, 
    // force a window refresh to clean up lingering memory states safely.
    window.location.reload();
  };

  return logout;
}